export class PagedTableRequest {
  orderBy: string;
  filter: string;
  orderMode: string;
  blockNumber: number;
  itemsPerBlock: number;
}

export enum OrderMode {
  ASC = 'ASC',
  DESC = 'DESC'
}


export enum QueryRequest {
  authLogin = 'authapi/v1/login',
  authPassword = 'authapi/v1/password',
  authLoginByToken = 'authapi/v1/login-by-token',
  authLoginByCertificate = 'authapi/v1/login-by-certificate',
  authLogout = 'authapi/v1/logout',
  authRefreshToken = 'authapi/v1/refresh-token',
  authEchoPing = 'authapi/v1/echoping',
  personalSSODomain = 'personalapi/v2/domains',
  authCheckDomain = 'authapi/v1/checkdomain',
  listPersonalCertificates = 'personalapi/v1/certificate/list',
  listPersonalCertificateIds = 'personalapi/v1/certificate/list-ids',
  personalCertificate = 'personalapi/v1/certificate',
  personalCertificateResetPin = 'personalapi/v1/certificate/reset-pin',
  personalCertificateChangePin = 'personalapi/v1/certificate/change-pin',
  fpCertificateDownload = 'personalapi/v1/certificate/fp/download',
  preloadedCertificates = 'personalapi/v1/preloaded-certificate/list',
  preloadedCertificatesIds = 'personalapi/v1/preloaded-certificate/list-ids',
  preloadCertificate = 'personalapi/v1/preloaded-certificate',
  preloadCertificateActivate = 'personalapi/v1/preloaded-certificate/activate',
  echoping = 'personalapi/v1/echoping',
  customdata = 'personalapi/v1/customdata',
  spConfig = 'personalapi/v1/sp-config',
  languages = 'personalapi/v1/languages',
  user = 'personalapi/v1/user',
  userLanguage = 'personalapi/v1/user/language',
  userPassword = 'authapi/v1/user/password',
  userPin = 'personalapi/v1/user/pin',
  userPinCode = 'personalapi/v1/user/pin/pincode',
  userPreference = 'personalapi/v1/user/preference',
  // OBSOLETE SIGNTRUST PROFILE ENDPOINTS:
  userSignatureImage = 'personalapi/v1/user/signature',
  userSignProfile = 'personalapi/v1/user/signature-profile',
  // =====================================
  // NEW SIGNTRUST PROFILE ENDPOINTS:
  signProfile = 'personalapi/v1/profile',
  signImage = 'personalapi/v1/profile/image',
  signLastPosition = 'personalapi/v1/last-position',
  // ================================
  signRemoteDocument = 'personalapi/v1/signremotedocument',
  sign = 'personalapi/v2/sign',
  signCertificateList = 'personalapi/v1/sign/certificate/list',
  signCheckPin = 'personalapi/v1/sign/certificate/checkpin',
  personalCertificateRemovePin = 'personalapi/v1/certificate/remove-pin'
}


export enum ContentType {
  jsonType = 'application/json',
  formDataType = 'multipart/form-data',
  pdfType = 'application/pdf'
}
